<template>
  <div class="reward-gift">
    <i class="icon-notification"></i>
    <p v-if="isStatePendingPay">
      恭喜您获得“<span class="pf-medium">{{ name }}</span
      >”赠品资格，请尽快支付获得赠品。
    </p>
    <p v-else>
      恭喜您获得“<span class="pf-medium">{{ name }}</span
      >”，活动结束后联系您身边育儿顾问领取。
    </p>
  </div>
</template>
<script>
import { ORDER_STATE_ENUM } from '@/config'
export default {
  props: {
    list: Array,
    order: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    let name = this.list.reduce((pre, cur) => {
      return pre + cur.promotionName + '、'
    }, '')
    name = name.substr(0, name.length - 1)
    return {
      name
    }
  },
  computed: {
    isStatePendingPay() {
      return this.order && ORDER_STATE_ENUM.PENDING_PAY == this.order.orderState
    }
  }
}
</script>
<style lang="scss" scoped>
.reward-gift {
  display: flex;
  align-items: center;
  font-size: 0.26rem;
  color: #ff5900;
  line-height: 0.38rem;
  background: #fff9ed;
  padding: 0.2rem 0.24rem;
  margin-top: 0.1rem;
}
.icon-notification {
  display: inline-block;
  width: 0.36rem;
  height: 0.36rem;
  background-image: url('~@/assets/images/product/new/icon-notification.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 0.16rem;
}
</style>
